import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		icon: {
			position: "absolute",
			right: "0",
			pointerEvents: "none",
		},
		adornedEnd: {
			paddingRight: 5,
		},
		button: {
			paddingLeft: 15,
			paddingRight: 15,
		},
		errorMessage: {
			color: theme.palette.error.main,
			fontWeight: "bold",
		}
	} satisfies Record<string, CSSObject>);
};
